function init_contact(e, placemarks) {

//====== MAP =====//

    let elem = document.getElementById(e);
    let clickCallback = function (e) {
        peaker.showAddressData(e.get('objectId'));
        peaker.selectAddressInPeaker(e.get('objectId'));
        map.setActivePlacemark(e.get('objectId'), true);
        showDataArea(accordion);
    }

    let params = {
        center: {
            lat: $(elem).attr('data-center-lat'),
            lon: $(elem).attr('data-center-lon'),
        },
        zoom: $(elem).attr('data-zoom'),
        clickCallback: clickCallback
    }


    let map = new YaMap(e, placemarks, params);
    window.map_ = map;
    map.render();
    //====== PEAKER =====//

    let peaker = new AddressPeaker('address_peaker');
    let event = function () {
        let placemark_id = peaker.getSelectedOptionValue();
        map.setActivePlacemark(placemark_id, true);
        peaker.showAddressData(placemark_id);
    }

    peaker.bindSelectEvent(event);
    //====== FILTER =====//
    let filterCallback = function (filters) {
        let result = map.filter(filters);
        let str = 'филиалов';
        if (Intl != undefined) {
            let d = new Intl.PluralRules('ru-RU');
            let r = {
                'one': 'филиал',
                'few': 'филиала',
                'many': 'филиалов',
                'other': 'филиалов',
            }
            str = r[d.select(result.length)];
        }
        $('.branch-count').html(result.length +' '+ str)
        if (result.length != 0) {
            peaker.bildAddressPeaker(result);
            peaker.bindSelectEvent(event);
            map.setActivePlacemark(result[0].id);
            peaker.showAddressData(result[0].id);
            map.setBounds(map.getMap());
            filter.disableFilterData(result);
        }
    }

    let filter = new YaMapFilter('filter_form', filterCallback);
    //====== ACCORDION =====//

    let accordion = $('#geography-data');
    function showDataArea(e) {
        e.addClass('in');
        e.find('.hidden-area').slideDown();
    }

    $('.address_area_trigger').on('click', function () {
        accordion.toggleClass('in');
        accordion.find('.hidden-area').slideToggle();
    });
    $(document).ready(function () {
        setTimeout(function () {
            $('#filter_form input[type=checkbox]').change()
        }, 1000);
    })
}